import { render, staticRenderFns } from "./TextGeneric.vue?vue&type=template&id=1dfe35de&"
import script from "./TextGeneric.ts?vue&type=script&lang=ts&"
export * from "./TextGeneric.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports